import React from 'react'
import { withFirebase } from '../Fb'
import moment from 'moment'
import { Row, Col, Card, CardHeader, CardTitle, CardBody } from 'reactstrap'
import ReactTable from '../Lists/ReactTableWrapper'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Table from '@mui/material/Table'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import Divider from '@mui/material/Divider'

const STATUS_OPTIONS = [
  { value: 'created', label: 'Luotu' },
  { value: 'confirmed', label: 'Vahvistettu' },
  { value: 'paid', label: 'Maksettu' },
  { value: 'delivered', label: 'Toimitettu' },
  { value: 'cancelled', label: 'Peruttu' },
]

const emptyAddress = { address: '', zip: '', city: '' }

const escapeHtml = (s) =>
  String(s == null ? '' : s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')

class ProshopOrdersContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      orders: [],
      addressOrder: null,
      addressForm: emptyAddress,
      savingAddress: false,
      detailsOrder: null,
    }
  }

  componentDidMount() {
    this.updateData()
  }

  updateData = () => {
    this.setState({ loading: true })
    this.props.firebase.getCustomerProshopOrders().then((snap) => {
      const orders = snap && !snap.empty
        ? snap.docs.map((d) => this.decorate({ ...d.data(), id: d.id }))
        : []
      // newest first
      orders.sort((a, b) => (b._sortts || 0) - (a._sortts || 0))
      this.setState({ orders, loading: false })
    })
  }

  decorate = (order) => {
    const payer = order.payer || {}
    const orderlines = order.orderlines || []
    const total = orderlines.reduce((acc, l) => acc + (l.sum || 0), 0)
    return {
      ...order,
      customerName: `${payer.firstname || ''} ${payer.lastname || ''}`.trim(),
      customerEmail: payer.email || '',
      itemsStr: `${orderlines.length} kpl`,
      totalStr: `${total.toFixed(2)} €`,
      dateStr: order.timestamp ? moment(order.timestamp).format('DD.MM.YYYY HH:mm') : '',
      _sortts: order.timestamp ? new Date(order.timestamp).getTime() : 0,
    }
  }

  handleStatusChange = (id, value) => {
    this.setState((s) => ({
      orders: s.orders.map((o) => (o.id === id ? { ...o, status: value } : o)),
    }))
    this.props.firebase.updateCustomerProshopOrder(id, { status: value })
  }

  openDetails = (order) => {
    this.setState({ detailsOrder: order })
  }

  closeDetails = () => {
    this.setState({ detailsOrder: null })
  }

  openAddress = (order) => {
    this.setState({
      addressOrder: order,
      addressForm: { ...emptyAddress, ...(order.deliveryAddress || {}) },
    })
  }

  closeAddress = () => {
    this.setState({ addressOrder: null, addressForm: emptyAddress, savingAddress: false })
  }

  setAddressField = (field, value) => {
    this.setState((s) => ({ addressForm: { ...s.addressForm, [field]: value } }))
  }

  saveAddress = () => {
    const { addressOrder, addressForm } = this.state
    if (!addressOrder) return
    this.setState({ savingAddress: true })
    const deliveryAddress = { ...addressForm }
    this.props.firebase
      .updateCustomerProshopOrder(addressOrder.id, { deliveryAddress })
      .then(() => {
        this.setState((s) => ({
          orders: s.orders.map((o) =>
            o.id === addressOrder.id ? { ...o, deliveryAddress } : o
          ),
        }))
        this.closeAddress()
      })
  }

  getColumns = () => [
    { Header: 'Tilausnumero', accessor: 'ordernumber', width: 200 },
    { Header: 'Päivä', accessor: 'dateStr', width: 150 },
    { Header: 'Asiakas', accessor: 'customerName', width: 180 },
    { Header: 'Sähköposti', accessor: 'customerEmail', width: 220 },
    { Header: 'Tuotteet', accessor: 'itemsStr', width: 100 },
    { Header: 'Summa', accessor: 'totalStr', width: 110 },
    {
      Header: 'Tila',
      accessor: 'status',
      width: 160,
      renderCell: (params) => (
        <Select
          size='small'
          value={STATUS_OPTIONS.some((o) => o.value === params.row.status) ? params.row.status : ''}
          displayEmpty
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => this.handleStatusChange(params.row.id, e.target.value)}
          sx={{ width: '100%' }}
        >
          {!STATUS_OPTIONS.some((o) => o.value === params.row.status) && (
            <MenuItem value=''>{params.row.status || '-'}</MenuItem>
          )}
          {STATUS_OPTIONS.map((o) => (
            <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
          ))}
        </Select>
      ),
    },
    {
      Header: ' ',
      accessor: 'details',
      width: 100,
      renderCell: (params) => (
        <Button
          size='small'
          onClick={(e) => {
            e.stopPropagation()
            this.openDetails(params.row)
          }}
        >
          Tiedot
        </Button>
      ),
    },
    {
      Header: ' ',
      accessor: 'actions',
      width: 160,
      renderCell: (params) => (
        <Button
          size='small'
          variant='outlined'
          onClick={(e) => {
            e.stopPropagation()
            this.openAddress(params.row)
          }}
        >
          Toimitusosoite
        </Button>
      ),
    },
  ]

  render() {
    const { addressOrder, addressForm } = this.state
    return (
      <div className='content'>
        <Row>
          <Col md='12'>
            <Card>
              <CardHeader>
                <CardTitle tag='h5'>Tilaukset</CardTitle>
              </CardHeader>
              <CardBody>
                {this.state.loading ? (
                  'Ladataan ...'
                ) : (
                  <ReactTable
                    data={this.state.orders}
                    columns={this.getColumns()}
                    height='calc(100vh - 300px)'
                    noSumRow
                    noDataText='Ei tilauksia'
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Dialog open={!!addressOrder} onClose={this.closeAddress} fullWidth maxWidth='sm'>
          <DialogTitle>Toimitusosoite</DialogTitle>
          <DialogContent>
            {addressOrder && (
              <Box sx={{ mb: 2 }}>
                <Typography variant='subtitle2' color='textSecondary'>
                  Tilaus {addressOrder.ordernumber} — {addressOrder.customerName}
                </Typography>
                {(addressOrder.orderlines || []).map((l, i) => (
                  <Typography key={i} variant='body2' color='textSecondary'>
                    {l.count || 1} × {l.name}
                  </Typography>
                ))}
              </Box>
            )}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
              <TextField
                label='Katuosoite'
                value={addressForm.address}
                onChange={(e) => this.setAddressField('address', e.target.value)}
                fullWidth
              />
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField
                  label='Postinumero'
                  value={addressForm.zip}
                  onChange={(e) => this.setAddressField('zip', e.target.value)}
                  sx={{ width: 160 }}
                />
                <TextField
                  label='Postitoimipaikka'
                  value={addressForm.city}
                  onChange={(e) => this.setAddressField('city', e.target.value)}
                  fullWidth
                />
              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.closeAddress}>Peruuta</Button>
            <Button variant='contained' disabled={this.state.savingAddress} onClick={this.saveAddress}>
              Tallenna
            </Button>
          </DialogActions>
        </Dialog>

        {this.renderDetailsDialog()}
      </div>
    )
  }

  renderDetailsDialog = () => {
    const order = this.state.detailsOrder
    if (!order) return null
    const orderlines = order.orderlines || []
    const payments = order.payments || []
    const total = orderlines.reduce((acc, l) => acc + (l.sum || 0), 0)
    const statusLabel = (STATUS_OPTIONS.find((o) => o.value === order.status) || {}).label || order.status || '-'
    const addr = order.deliveryAddress
    return (
      <Dialog open onClose={this.closeDetails} fullWidth maxWidth='md'>
        <DialogTitle>Tilaus {order.ordernumber}</DialogTitle>
        <DialogContent>
          <Box sx={{ mb: 2 }}>
            <Typography variant='body2'>
              {order.customerName} — {order.customerEmail}
            </Typography>
            <Typography variant='body2' color='textSecondary'>
              {order.timestamp ? moment(order.timestamp).format('DD.MM.YYYY HH:mm') : ''} · Tila: {statusLabel}
            </Typography>
          </Box>

          <Typography variant='subtitle2' sx={{ mb: 1 }}>Ostoskori</Typography>
          <Table size='small'>
            <TableHead>
              <TableRow>
                <TableCell>Tuote</TableCell>
                <TableCell align='right'>Määrä</TableCell>
                <TableCell align='right'>Yksikköhinta</TableCell>
                <TableCell align='right'>Alv</TableCell>
                <TableCell align='right'>Summa</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {orderlines.map((l, i) => (
                <TableRow key={i}>
                  <TableCell>{l.name}</TableCell>
                  <TableCell align='right'>{l.count || 1}</TableCell>
                  <TableCell align='right'>{(l.unitprice || 0).toFixed(2)} €</TableCell>
                  <TableCell align='right'>{l.vat != null ? `${l.vat} %` : ''}</TableCell>
                  <TableCell align='right'>{(l.sum || 0).toFixed(2)} €</TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell colSpan={4} align='right' sx={{ fontWeight: 700, border: 0 }}>Yhteensä</TableCell>
                <TableCell align='right' sx={{ fontWeight: 700, border: 0 }}>{total.toFixed(2)} €</TableCell>
              </TableRow>
            </TableBody>
          </Table>

          <Divider sx={{ my: 2 }} />

          <Typography variant='subtitle2' sx={{ mb: 1 }}>Maksut</Typography>
          {payments.length === 0 ? (
            <Typography variant='body2' color='textSecondary'>Ei maksutietoja</Typography>
          ) : (
            payments.map((p, i) => (
              <Typography key={i} variant='body2'>
                {(p.amount != null ? p.amount.toFixed(2) : '')} € · {p.typelabel || p.type || ''} · {p.timestamp || ''}
              </Typography>
            ))
          )}

          {addr && (addr.address || addr.zip || addr.city) && (
            <>
              <Divider sx={{ my: 2 }} />
              <Typography variant='subtitle2' sx={{ mb: 1 }}>Toimitusosoite</Typography>
              {addr.address && <Typography variant='body2'>{addr.address}</Typography>}
              {(addr.zip || addr.city) && <Typography variant='body2'>{addr.zip} {addr.city}</Typography>}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.printLabel(order)}>Tulosta osoitetarra</Button>
          <Button onClick={this.closeDetails}>Sulje</Button>
        </DialogActions>
      </Dialog>
    )
  }

  // Resolve the delivery address (order.deliveryAddress, else the user record)
  // and open a print-ready address label window.
  printLabel = async (order) => {
    const payer = order.payer || {}
    const name = `${payer.firstname || ''} ${payer.lastname || ''}`.trim()
    let addr = order.deliveryAddress
    if (!addr || !(addr.address || addr.zip || addr.city)) {
      try {
        const doc = payer.id ? await this.props.firebase.user(payer.id).get() : null
        const u = doc && doc.exists ? doc.data() : {}
        addr = { address: u.streetaddress || '', zip: u.zip || '', city: u.city || '' }
      } catch (e) {
        addr = { address: '', zip: '', city: '' }
      }
    }
    this.openPrintWindow({
      name,
      address: addr.address || '',
      zip: addr.zip || '',
      city: addr.city || '',
      ordernumber: order.ordernumber || '',
    })
  }

  openPrintWindow = (label) => {
    const w = window.open('', '_blank', 'width=600,height=400')
    if (!w) return
    w.document.write(
      '<html><head><title>Osoitetarra</title><style>' +
        '@page { size: 100mm 60mm; margin: 6mm; }' +
        'body { font-family: Arial, sans-serif; margin: 0; padding: 10mm; }' +
        '.name { font-size: 22px; font-weight: bold; margin-bottom: 8px; }' +
        '.line { font-size: 18px; line-height: 1.5; }' +
        '.muted { color: #666; font-size: 12px; margin-top: 16px; }' +
        '</style></head><body>' +
        '<div class="name">' + escapeHtml(label.name) + '</div>' +
        '<div class="line">' + escapeHtml(label.address) + '</div>' +
        '<div class="line">' + escapeHtml(label.zip) + ' ' + escapeHtml(label.city) + '</div>' +
        '<div class="muted">Tilaus ' + escapeHtml(label.ordernumber) + '</div>' +
        '<scr' + 'ipt>window.onload=function(){window.print();}</scr' + 'ipt>' +
        '</body></html>'
    )
    w.document.close()
  }
}

export default withFirebase(ProshopOrdersContainer)
